import React, { useContext } from 'react'
import { AuthContext } from "../contexts/AuthContext";
import CIcon from '@coreui/icons-react'
import { cilGroup, cilSpeedometer, cilDrink, cilRestaurant } from '@coreui/icons'
import { CNavItem } from '@coreui/react'

const getNavigation = (user) => {
  let { user1 } = useContext(AuthContext);

  const nav = [
    {
      component: CNavItem,
      name: 'Dashboard',
      to: '/dashboard',
      icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    },
    // {
    //   component: CNavItem,
    //   name: 'Bebidas registradas',
    //   to: '/bebidas',
    //   icon: <CIcon icon={cilDrink} customClassName="nav-icon" />,
    // },
  ]

  // solo restaurant
  if (user1?.role === 'restaurant') {
    nav.push(
      {
        component: CNavItem,
        name: 'Entrega bebidas',
        to: '/entregaBeneficios',
        icon: <CIcon icon={cilDrink} customClassName="nav-icon" />,
      }
    )
  }

  // solo master
  if (user1?.role === 'master') {
    nav.push({
      component: CNavItem,
      name: 'Restaurantes',
      to: '/restaurantes',
      icon: <CIcon icon={cilRestaurant} customClassName="nav-icon" />,
    })
  }

  if (user1?.role === 'master') {
    nav.push({
      component: CNavItem,
      name: 'Usuarios',
      to: '/usuarios',
      icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
    })
  }

  if (user1?.role === 'master') {
    nav.push({
      component: CNavItem,
      name: 'Administradores',
      to: '/admins',
      icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
    })
  }

  return nav
}

export default getNavigation
